<div id="subscription">
	<!-- Anonymous or  login and not scribe -->
	<div *ngIf="status === 1">
		<button class="btn btn-outline-info" (click)="subscribe()" tabindex="0">Subscribe to Activity Report</button>
		<i role="button" class="icnCircleInfo" style="color: #3498db; font-size: 20px; vertical-align: middle; margin-left: 5px;" (click)="dsiplaySample();"></i>
	</div>
	<!-- login and scribe -->
	<div *ngIf="status === 2">
		<button class="btn btn-outline-info" (click)="unsubscribe(null)" tabindex="0">Unsubscribe from Activity Report</button>
		<i *ngIf="subscription.Email===''" role="button" class="fas fa-envelope-square" style="color: red; font-size: 20px; vertical-align: middle; margin-left: 5px;" (click)="noEmail();"></i>
	</div>
	<div *ngIf="status === 99" class="jmWidgetLoadingIcon20"></div>
</div>
